import { Shell, type ScreenProps } from "./common";

/** Инструкция внутри приложения — про работу, а не про установку.
 *  Про установку есть отдельная страница /pamyatka, она нужна до первого запуска. */
export default function Help({ updateReady, back, state, user }: ScreenProps) {
  return (
    <Shell title="Как пользоваться" onBack={back} state={state} updateReady={updateReady}>

      <div className="sub" style={{ marginTop: 0 }}>Записать визит</div>
      <p style={{ marginTop: 0 }}>
        На главном экране найдите точку — поиском по названию или адресу, либо фильтрами
        по типу: аптеки, стоматологии, подологи, косметологи. Сверху всегда те,
        где давно не были.
      </p>
      <p>
        Над списком переключатель <b>«Мои точки / Все»</b>. В «Моих» — точки вашего
        направления, плюс всё, что вы сами завели и где сами были. База общая на всех
        сотрудников, поэтому во «Всех» точек заметно больше. Если ищете точку и в «Моих»
        её нет — приложение подскажет, что она есть среди остальных: <b>не заводите
        её второй раз</b>, откройте существующую.
      </p>
      <p>
        Нажмите на точку. Первое, что видно, — <b>прошлый визит целиком</b>: дата, ваше
        резюме, что оставляли, о чём договорились. Ниже история и контактные лица.
      </p>
      <p>
        Кнопка <b>«Новый визит»</b>. Геометка встанет сама. Резюме проще надиктовать —
        см. ниже. Отметьте, что оставили, пройдите чек-лист выкладки, сфотографируйте
        полку и сохраните.
      </p>

      <div className="sub">Диктовка резюме</div>
      <p style={{ marginTop: 0 }}>
        Справа от подписи «Резюме визита» есть кнопка <b>🎤 Диктовать</b>. Нажмите её
        и говорите обычным голосом — текст появится в поле сам. Кнопка станет красной,
        пока идёт запись; чтобы закончить, нажмите <b>«Стоп»</b>. Диктовать и править
        руками можно вперемешку: распознанное дописывается в конец, уже набранное
        не затирается.
      </p>
      <p>
        В первый раз браузер спросит разрешение на микрофон — нажмите «Разрешить»,
        иначе кнопка работать не будет. Больше он не спросит.
      </p>
      <p>
        Говорите короткими фразами с паузами — так распознаётся точнее, чем длинным
        потоком. Знаки препинания сами не ставятся: их проговаривают вслух («точка»,
        «запятая») или дописывают потом руками.
      </p>
      <div className="note">
        <b>Диктовке нужен интернет</b> — распознавание идёт не в планшете. Если связи нет,
        приложение так и скажет. Тогда диктуйте <b>микрофоном на клавиатуре</b> планшета:
        он умеет работать офлайн, если в настройках Android скачан русский языковой пакет.
        Всё остальное в приложении интернета не требует.
      </div>
      <p>
        <b>Перечитывайте перед сохранением.</b> Чаще всего распознаватель ошибается
        как раз в том, что важнее всего, — в цифрах, датах и названиях продукции.
      </p>
      <p>
        <a className="btn tiny" href="/pamyatka/golos" target="_blank" rel="noreferrer">
          Подробная памятка по диктовке
        </a>
      </p>

      <div className="sub">Фотографии</div>
      <p style={{ marginTop: 0 }}>
        Две кнопки: <b>«Снять»</b> — камерой планшета, <b>«Из галереи»</b> — уже готовый
        снимок, можно выбрать сразу несколько.
      </p>
      <p>
        Посмотреть снимки можно в <b>карточке точки</b>: у последнего визита они видны
        сразу, у старых — по кнопке «📷 … фото». Нажатие открывает снимок во весь экран.
        Для фото с другого устройства нужен интернет — они лежат на сервере.
      </p>
      <p>
        Если планшетом снимать неудобно, фотографируйте телефоном, а прикладывайте позже —
        необязательно успевать в момент визита. Откройте точку и нажмите
        <b> «Дополнить визит»</b> (или на нужный визит в списке предыдущих), добавьте фото
        и сохраните. Дата визита при этом не меняется.
      </p>
      <p>Способа два, оба рабочие:</p>
      <p>
        <b>Через Telegram</b> — отправить снимки себе в «Избранное», на планшете сохранить
        в галерею и приложить кнопкой «Из галереи». Ставить ничего не надо, и Telegram
        заодно переводит фото с айфона в формат, который планшет откроет.
      </p>
      <p>
        <b>Приложение на телефоне</b> — открыть <b>crm.natusana.by</b> в Chrome
        на телефоне и войти своим же логином и паролем. Тогда переносить нечего:
        сняли и сразу приложили. Фильтр <b>«🕐 Недавние»</b> вверху списка точек покажет
        те, где вы были на этой неделе.
      </p>
      <div className="note">
        До пяти фото на визит, счёт общий на оба устройства. Снимки видны там, где сделаны:
        открыв визит с телефона, вы не увидите фото с планшета — приложение напишет,
        сколько их. Они на сервере и никуда не денутся.
      </div>
      <p>
        <a className="btn tiny" href="/pamyatka/foto" target="_blank" rel="noreferrer">
          Памятка «Фото с телефона»
        </a>
      </p>

      <div className="sub">Чек-лист выкладки</div>
      <p style={{ marginTop: 0 }}>
        Он появляется только у аптек и строится из матрицы — перечня позиций, которые
        в этой точке должны стоять. Позиции сгруппированы: пасты, щётки, ополаскиватели
        и так далее. Заголовок группы сворачивается, если она сейчас не нужна.
      </p>
      <p>
        Переключатель <b>«Чего не было»</b> оставляет только те позиции, которых
        не оказалось на полке в прошлый визит. Если ассортимент стабильный, обычно
        достаточно пройти этот короткий список.
      </p>

      <div className="sub">Значок вверху справа</div>
      <div className="list" style={{ marginTop: 0 }}>
        <div className="item" style={{ cursor: "default" }}>
          <span className="sync ok" style={{ margin: 0 }}><span className="dot" />всё отправлено</span>
          <span className="main"><span className="meta">Всё на сервере, делать нечего</span></span>
        </div>
        <div className="item" style={{ cursor: "default" }}>
          <span className="sync wait" style={{ margin: 0 }}><span className="dot" />не отправлено: 3</span>
          <span className="main"><span className="meta">Записи ждут связи. Уйдут сами</span></span>
        </div>
        <div className="item" style={{ cursor: "default" }}>
          <span className="sync off" style={{ margin: 0 }}><span className="dot" />нет сети</span>
          <span className="main"><span className="meta">Работать можно, всё сохранится</span></span>
        </div>
        <div className="item" style={{ cursor: "default" }}>
          <span className="sync err" style={{ margin: 0 }}><span className="dot" />ошибка обмена</span>
          <span className="main"><span className="meta">Что-то не так — загляните в Профиль</span></span>
        </div>
      </div>

      <div className="note">
        <b>Интернет для работы не нужен.</b> Всё записанное лежит в планшете и уходит
        на сервер само, как только появляется связь. Специально ничего нажимать не надо.
        Если хочется поторопить — Профиль, кнопка «Отправить сейчас».
      </div>

      <div className="sub">Чего делать не стоит</div>
      <p style={{ marginTop: 0 }}>
        Не выходите из приложения, пока значок показывает «не отправлено» — при выходе
        планшет стирает с себя данные, и неотправленные записи пропадут. Приложение
        предупредит, но лучше знать заранее.
      </p>

      {user.role === "manager" && (
        <>
          <div className="sub">Что можете вы как руководитель</div>
          <p style={{ marginTop: 0 }}>
            <b>Сотрудники и доступы</b> — завести человека, выписать ему ссылку,
            сбросить пароль, отозвать доступ у потерянного планшета.
          </p>
          <p>
            <b>Выдача раздатки</b> — записать, что выдали сотруднику. После этого позиция
            появится у него в списке «что оставил» и начнёт списываться по визитам.
            Выдаётся только <b>рекламная продукция</b> — пробники и материалы.
            Ассортимент Lacalut не выдаётся: его отмечают на полке в чек-листе выкладки.
          </p>
          <p>
            <b>Выгрузка визитов</b> — скачать визиты сотрудников за период одной таблицей
            Excel: дата, точка, комментарий, договорённости, выкладка. Без фото.
          </p>
          <p>
            Вы видите визиты всех сотрудников, медпред — только свои.
          </p>
        </>
      )}

      <div className="sub">Памятка по установке</div>
      <p style={{ marginTop: 0 }}>
        Если нужно поставить приложение на другой планшет — пошаговая инструкция лежит
        по адресу <b>crm.natusana.by/pamyatka</b>. Её же удобно отправлять новому
        сотруднику вместе со ссылкой-приглашением.
      </p>
    </Shell>
  );
}
